module.exports = __webpack_public_path__ + "img/D2-2-3-img01-en.a949528a.jpg";